import Skeleton from "react-loading-skeleton";

function SkeletonLoading() {
    return (
        <div className="container_post">
                <div className="content">        
                        <h1><Skeleton height={40} width={`40%`} /></h1>
                        <div className="blockcontent">
                            <Skeleton height={20} />
                            <Skeleton height={20} />
                            <Skeleton height={20} />
                            <Skeleton height={20} />
                            <Skeleton height={20} />
                        </div>
                        <Skeleton height={400} />

               </div>
        </div>
    )
}

export default SkeletonLoading
